const isProd = true;
export const newClinicLocalToken = "28db4e66b070ce5f6f445f2a713ce1adbe07d274";
export const appServerLocalToken = "06ff9dbd57ede946caf4e3210a929157c40c8e47";
export const BASE_URL = isProd ? "https://hud.mvrc.co.in" : "https://6fqm9v96-8000.inc1.devtunnels.ms";
export const NEW_CLINIC_BASE_URL = isProd ? "https://newclinic.mvrc.co.in" : "https://6fqm9v96-8000.inc1.devtunnels.ms";
export const APP_BASE_URL = isProd ? "https://app.mvrc.co.in" : "https://app.mvrc.co.in";
export const hudLoginApiUrl = `${BASE_URL}/api-token-auth/`;
export const hudDoctoViewGetUrl = `${BASE_URL}/hud/doctor-view-hud/`;
export const hudGetUserPhotosUrl = `${BASE_URL}/api/patients/`;
// `${BASE_URL}/api/patients/<patient-id>/history/photos/
export const invoiceFinancialDataGetApi = `${APP_BASE_URL}/invoice/financial-data/`;
export const invoiceHftDataGetApi = `${APP_BASE_URL}/invoice/hft-data/`;
export const hudDashboardGetApi = `${BASE_URL}/hud/dashboard`;
export const getDoctorPackageInvoice = `${APP_BASE_URL}/invoice/package-invoice-machine?machine_name=`;
export const doctorPackageStats = `${APP_BASE_URL}/invoice/package-stats/`;
export const monthlyPatientSummaryUrl = `${NEW_CLINIC_BASE_URL}/api/monthly-patient-summary/`;
export const adminStatsUrl = `${NEW_CLINIC_BASE_URL}/api/admin-stats/`;
export const branchWiseStatsUrl = `${NEW_CLINIC_BASE_URL}/api/admin-stats/?branch_name=`;
export const doctorFinancialStatsUrl = `${APP_BASE_URL}/invoice/admin-stats/?branch_name=`;
export const revenueSummaryUrl = `${APP_BASE_URL}/invoice/revenue-summary/`;
export const allCentersTptUrl = `${APP_BASE_URL}/lock_devices/all-centers-tpt/`;
export const tptDosesLastHourUrl = `${NEW_CLINIC_BASE_URL}/api/tpt-doses-last-hour/`;